import axios from "../utils/axios";

interface IRoleWithPermissions {
    id: number;
    name: string;
    description: string;
    isDefault: boolean;
    permissions: string[];
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    lastModifiedBy?: string;
}

interface IGetRolesResponse {
    status: number;
    result: {
        defaultRoles: IRoleWithPermissions[];
        customRoles: IRoleWithPermissions[];
    };
}

interface ICreateRoleData {
    name: string;
    description?: string;
    permissions: string[];
    baseRoleId?: number;
}

interface IUpdateRoleData {
    name?: string;
    description?: string;
    permissions?: string[];
}

interface IRoleResponse {
    status: number;
    result: IRoleWithPermissions;
}

interface IDeleteRoleResponse {
    status: number;
    result: { message: string };
    errorMessage?: string;
}

interface IRoleAssignment {
    uuidResearcher: string;
    roleId: number;
}

interface IAssignRoleBatchResponse {
    status: number;
    result: {
        assigned: Array<{
            uuid: string;
            email: string;
            name: string;
            surnames: string;
            units: any[];
            roleId: number;
            roleName: string;
            permissions: string[];
        }>;
        errors?: Array<{ uuidResearcher: string; error: string }>;
        summary: { total: number; successful: number; failed: number };
    };
}

interface IPermissionItem {
    value: string;
    description: string;
}

interface IGetPermissionsResponse {
    status: number;
    result: IPermissionItem[];
}

export function getPermissionsService(uuidInvestigation?: string): Promise<IGetPermissionsResponse> {
    const url = import.meta.env.VITE_APP_API_URL + "/roles/permissions" +
        (uuidInvestigation ? "?uuidInvestigation=" + encodeURIComponent(uuidInvestigation) : "");
    return new Promise((resolve, reject) => {
        axios
            .get(url, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getRolesForInvestigationService(uuidInvestigation: string): Promise<IGetRolesResponse> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/roles/investigation/" + uuidInvestigation + "/roles", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function createCustomRoleService(uuidInvestigation: string, roleData: ICreateRoleData): Promise<IRoleResponse> {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/roles/investigation/" + uuidInvestigation + "/roles", roleData, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 201 || response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateCustomRoleService(uuidInvestigation: string, roleId: number, roleData: IUpdateRoleData): Promise<IRoleResponse> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/roles/investigation/" + uuidInvestigation + "/roles/" + roleId, roleData, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function assignRoleBatchService(uuidInvestigation: string, assignments: IRoleAssignment[]): Promise<IAssignRoleBatchResponse> {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/roles/investigation/" + uuidInvestigation + "/roles/batch-assign", { assignments }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteCustomRoleService(uuidInvestigation: string, roleId: number): Promise<IDeleteRoleResponse> {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/roles/investigation/" + uuidInvestigation + "/roles/" + roleId, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
